export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_HASHED = "SIGN_IN_HASHED";
export const AUTO_SIGN_IN = "AUTO_SIGN_IN";
export const SSO_SIGN_IN = "SSO_SIGN_IN";
export const SIGN_UP = "SIGN_UP";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const CONFIRM_EMAIL = "CONFIRM_EMAIL";
export const RESEND_CODE = "RESEND_CODE";
export const PLAID_LINK_TOKEN = "PLAID_LINK_TOKEN";
export const VERIFY_GUEST = "VERIFY_GUEST";
export const LOGIN_AS_GUEST = "LOGIN_AS_GUEST";
export const RESTORE_DATA = "RESTORE_DATA";
export const CREATE_PASSWORD = "CREATE_PASSWORD";
export const RESTORE_REQUEST = "RESTORE_REQUEST";
export const UPDATE_STOCK = "UPDATE_STOCK";
export const UPDATE_COIN = "UPDATE_COIN";
export const RESEND_CODE_PASS = "RESEND_CODE_PASS";
export const VERIFY_CODE_PASS = "VERIFY_CODE_PASS";
export const DEFAULT_TIMER_VAL = 300; // sec
export const GET_SSO_OTP = "GET_SSO_OTP";
export const SET_SSO_PASS = "SET_SSO_PASS";
export const GET_SIGNUP_CODE = "GET_SIGNUP_CODE";
export const GET_ONRAMP_RESPONSE = "GET_ONRAMP_RESPONSE";
export const PASSWORD_LESS_SIGNIN = "PASSWORD_LESS_SIGNIN";
export const GENERATE_TOKEN_NEW_USER = "GENERATE_TOKEN_NEW_USER";
export const PASSWORDLESS_SIGNIN = "PASSWORDLESS_SIGNIN";
export const CHECK_EMAIL = "CHECK_EMAIL";
export const SECURE_SIGN_UP = "SECURE_SIGN_UP";
export const GET_HOSTED_PAGE_INFO = "GET_HOSTED_PAGE_INFO";
export const GET_WHITE_LABEL_INFO = "GET_WHITE_LABEL_INFO";
export const ALCHEMY_DOMAIN = "api.g.alchemy.com";

export const erc20AbiCustom = [
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [{ name: "", type: "bool" }],
  },
  {
    type: "function",
    name: "transfer",
    stateMutability: "nonpayable",
    inputs: [
      { name: "to", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [{ name: "", type: "bool" }],
  },
  {
    type: "function",
    name: "transferFrom",
    stateMutability: "nonpayable",
    inputs: [
      { name: "sender", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [{ name: "", type: "bool" }],
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [{ name: "account", type: "address" }],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    type: "function",
    name: "allowance",
    stateMutability: "view",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
    ],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint8" }],
  },
  {
    type: "function",
    name: "symbol",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "string" }],
  },
  {
    type: "function",
    name: "name",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "string" }],
  },
];
